import React from 'react';
import LogoFull from '../../images/logo-full.svg';

const Logo = () => {
  return (
    <a className="logo" href='http://rocketnote.co'>
      <img src={LogoFull} alt='Rocket Note logo' />
    </a>
  );
};

export default Logo;
